import LegalPage from "@/pages/LegalPage";

const SECTIONS = [
  {
    h: "App Store Purchases",
    p: [
      "If you purchase a Trainova subscription or other digital service through the Apple App Store, your purchase is processed and managed by Apple.",
      "Refund eligibility for App Store purchases is determined by Apple in accordance with Apple's refund policies. Trainova does not control Apple's approval or denial of refund requests.",
      "To request a refund for a purchase made through the Apple App Store, visit Apple's Report a Problem service (reportaproblem.apple.com) and follow the instructions to submit a refund request.",
      "Canceling a subscription does not automatically result in a refund. Unless otherwise determined by Apple or required by applicable law, you may continue to have access to your subscription benefits until the end of your current paid subscription period.",
    ],
  },
  {
    h: "Google Play Purchases",
    p: [
      "If you purchase a Trainova subscription or other digital service through Google Play, your purchase is processed through Google Play.",
      "Refund eligibility is subject to Google Play's refund policies and applicable law. Depending on the circumstances and how recently the purchase was made, Google may allow you to request a refund directly through Google Play.",
      "For certain purchases, Google may direct you to contact Trainova regarding a refund request.",
      "Canceling a Google Play subscription generally stops future renewals. Unless a refund is approved or applicable law provides otherwise, you may continue to have access to your subscription benefits through the end of the current paid billing period.",
    ],
  },
  {
    h: "Subscription Cancellations",
    p: [
      "Trainova subscriptions may automatically renew unless canceled before the next renewal date.",
      "Deleting your Trainova account or uninstalling the Trainova app does not automatically cancel an active subscription.",
      "You must cancel your subscription through the platform where you originally purchased it:",
      "Apple App Store: Manage or cancel the subscription through your Apple Account subscription settings.",
      "Google Play: Manage or cancel the subscription through your Google Play subscription settings.",
      "Once canceled, you will not be charged for subsequent renewal periods unless you subscribe again.",
    ],
  },
  {
    h: "Refund Eligibility",
    p: [
      "Refunds are not guaranteed simply because a user no longer wishes to use Trainova, does not use the subscription, or forgets to cancel before renewal.",
      "However, refund requests may be considered or granted when required by Apple, Google Play, Trainova's applicable policies, or applicable consumer protection laws.",
      "Nothing in this policy limits any refund, cancellation, withdrawal, or other consumer rights that cannot legally be waived in your country or region.",
    ],
  },
  {
    h: "Unauthorized Purchases",
    p: [
      "If you believe a purchase was made without your authorization, please report the transaction promptly through the Apple App Store or Google Play, depending on where the purchase occurred.",
    ],
  },
  {
    h: "Technical or Purchase Issues",
    p: [
      "If you purchased a Trainova feature or subscription but did not receive access to it, please contact us so we can investigate the issue.",
      "Trainova Support — support@trainovaapp.com",
      "When contacting us, please include enough information for us to identify and investigate the transaction. Do not send full credit card or payment information by email.",
    ],
  },
  {
    h: "Changes to This Policy",
    p: [
      "Trainova may update this Refund & Cancellation Policy from time to time. Any changes will be posted with an updated \u201cLast Updated\u201d date. Where required by applicable law, we will provide additional notice of material changes.",
    ],
  },
  {
    h: "Contact Us",
    p: [
      "If you have questions regarding this Refund & Cancellation Policy, contact: support@trainovaapp.com",
    ],
  },
];

export default function Refund() {
  return (
    <LegalPage
      testid="refund-page"
      eyebrow="CLEAR & FAIR"
      title="Refund &"
      accent="cancellation"
      subtitle="Thank you for using Trainova. This Refund & Cancellation Policy explains how refunds and cancellations are handled for purchases and subscriptions made through the Trainova mobile application."
      updated="August 13, 2026"
      sections={SECTIONS}
    />
  );
}
